module.exports = __webpack_public_path__ + "static/realizacjeBg2-e65f7f687aba0691785373a97106ec18.png";